import { gql } from '@apollo/client'

//Lookup Queries
export const GET_BOOKING_SEARCH_TRIP = gql`
    query SearchTrip($fromLocationId: NonEmptyString!, $toLocationId: NonEmptyString!, $tripDate: Date!) {
        searchTrip(from_location_id: $fromLocationId, to_location_id: $toLocationId, trip_date: $tripDate) {
            code
            success
            message
            trips {
                route_id
                route {
                    route_id
                    route_name {
                        en
                        ar
                    }
                }
                trip_id
                trip {
                    trip_id
                    trip_name {
                        en
                        ar
                    }
                    start_time
                    end_time
                }
                start {
                    location_id
                    stop_number
                    arrival_time
                    departure_time
                    location {
                        id
                        name {
                            en
                            ar
                        }
                    }
                }
                end {
                    location_id
                    stop_number
                    arrival_time
                    departure_time
                    location {
                        name {
                            en
                            ar
                        }
                    }
                }
                available_seats {
                    code
                    description {
                        en
                        ar
                    }
                    available
                }
                price {
                    seat_type_code
                    consolidated {
                        ADL
                        CHD
                        INF
                        SNR
                    }
                }
                middle_stops {
                    location_id
                    stop_number
                    arrival_time
                    departure_time
                    location {
                        name {
                            en
                            ar
                        }
                    }
                }
            }
        }
    }
`

export const GET_BOAT_ROUTE_SEAT_AVAILABILITY = gql`
    query GetBoatRouteTripSeatAvailability(
        $tripId: NonEmptyString!
        $startLocationId: NonEmptyString!
        $endLocationId: NonEmptyString!
        $tripDate: LocalDate!
    ) {
        getBoatRouteTripSeatAvailability(
            trip_id: $tripId
            start_location_id: $startLocationId
            end_location_id: $endLocationId
            trip_date: $tripDate
        ) {
            code
            success
            message
            total_count
            seat_layout_key
            seats {
                seat_type
                seat_no
                seat_status
            }
            trip_id
            trip_date
            start_location_id
            end_location_id
            seatsummary {
                seat_type
                status_code
                status_description {
                    en
                    ar
                }
                seat_count
            }
        }
    }
`

export const GET_ALL_BOOKINGS_LIST = gql`
    query GetAllBookings($page: PageInput!, $bookingFilter: BookingFilterInput) {
        getAllBookings(page: $page, booking_filter: $bookingFilter) {
            code
            success
            message
            total_count
            bookings {
                booking_id
                user_id
                total_price
                booking_type {
                    code
                    description {
                        ar
                        en
                    }
                }
                metadata {
                    booking_type {
                        code
                        description {
                            ar
                            en
                        }
                    }
                    travel_date
                }
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
                trip_segments {
                    segment_id
                    booking_id
                    allow_check_in
                    trip_status
                    reschedule_allowed
                    trip_type
                    route {
                        route_id
                        route_name {
                            en
                            ar
                        }
                        master_route {
                            route_name {
                                en
                                ar
                            }
                            route_type {
                                code
                                description {
                                    en
                                    ar
                                }
                            }
                        }
                        boat {
                            id
                            name {
                                en
                                ar
                            }
                        }
                    }
                    trip_id
                    trip {
                        trip_name {
                            en
                            ar
                        }
                        start_time
                        end_time
                    }
                    start {
                        arrival_time
                        departure_time
                        location {
                            id
                            name {
                                en
                                ar
                            }
                        }
                    }
                    end {
                        arrival_time
                        departure_time
                        location {
                            id
                            name {
                                en
                                ar
                            }
                        }
                    }
                    travel_date
                    duration_minutes
                    trip_meals_summary {
                        meal_id
                        meal_name_en
                        meal_name_ar
                        meal_count
                    }
                    passengers {
                        passenger_id
                        passenger {
                            given_name
                            family_name
                            age_group_code
                            medical_condition
                            medical_remarks
                        }
                        check_in {
                            checkin_id
                            booking_id
                            passenger_id
                            luggage_count
                            travel_date
                            status { 
                                code
                                description {
                                    en
                                    ar
                                }
                            }
                            details {
                                remarks
                                counter_no  
                            }
                            user_audit {
                                created_by
                                created_date
                                modified_by
                                modified_date
                            }
                            luggages {
                                booking_id
                                checkin_id
                                travel_date
                                luggage_id
                                qr_code {
                                    encrypted
                                }
                                status { 
                                    code    
                                    description {
                                        en
                                        ar
                                    }
                                }
                                details { 
                                    weight  
                                    dimensions {
                                        length
                                        width
                                        height
                                    }   
                                    color
                                    tags
                                }   
                                user_audit {
                                    created_by
                                    created_date
                                    modified_by
                                    modified_date
                                }
                            } 
                        }
                    }
                }
                passengers {
                    passenger_id
                    segment_id
                    booking_id
                    travel_date
                    user_id
                    passenger {
                        given_name
                        family_name
                        date_of_birth
                        email
                        phone_number
                        document_type
                        document_number
                        age_group_code
                        special_needs
                    }
                    seat_info {
                        seat_no
                        seat_type_code
                    }
                    ticket_number
                    qr_code {
                        encrypted
                    }
                }
                booking_code
                user_audit {
                    created_by
                    created_date
                }
                price {
                    final_price
                }
            }
        }
    }
`
export const GET_ALL_BOOKINGS = gql`
    query GetAllBookings($page: PageInput!, $bookingFilter: BookingFilterInput) {
        getAllBookings(page: $page, booking_filter: $bookingFilter) {
            code
            success
            message
            total_count
            bookings {
                booking_id
                total_price
                user_id
                booking_type {
                    code
                    description {
                        ar
                        en
                    }
                }
                user {
                    id
                    email
                    user_info {
                        phone_number
                        phone_number_verified
                        given_name
                        family_name
                        nationality_code
                        date_of_birth
                        locale
                        photo {
                            file_name
                            size
                            mime_type
                            s3_key
                        }
                    }
                    user_roles
                    cognito_status
                    additional_info {
                        job_title
                        document_number
                        document_type {
                            code
                        }
                        document {
                            file_name
                            size
                            mime_type
                            s3_key
                        }
                        profile_photo {
                            file_name
                            size
                            mime_type
                            s3_key
                        }
                    }
                    is_active
                }
                metadata {
                    booking_id
                    travel_date
                    booking_code
                    booking_type {
                        description {
                            en
                            ar
                        }
                        code
                    }
                }
                receipt {
                    no
                    date
                    amount
                    time
                    card_brand
                    card_no
                    currency
                }
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
                trip_segments {
                 trip_id
                    segment_id
                    booking_id
                    allow_check_in
                    route_id
                    trip_status
                    reschedule_allowed
                    trip_type
                    trip_locations {
                        stop_number
                        location_id
                        location {
                            user_audit {
                                modified_by
                                modified_date
                                created_date
                                created_by
                            }
                            name {
                                en
                                ar
                            }
                            id
                            geo {
                                lng
                                lat
                            }
                            contact {
                                phone_number
                                email
                            }
                            address {
                                unit_no
                                road_no
                                landmark
                                contact
                                block_no
                                area
                            }
                        }
                        departure_time
                        arrival_time
                    }
                    route {
                        route_id
                        route_name {
                            en
                            ar
                        }
                        master_route {
                            route_name {
                                en
                                ar
                            }
                            route_type {
                                code
                                description {
                                    en
                                    ar
                                }
                            }
                        }
                        status_code
                        waypoints {
                            location_id
                            stop_number
                            status {
                                description {
                                    ar
                                    en
                                }
                                code
                            }
                            location {
                                name {
                                    en
                                    ar
                                }
                                id
                                geo {
                                    lng
                                    lat
                                }
                                contact {
                                    phone_number
                                    email
                                }
                                address {
                                    unit_no
                                    road_no
                                    landmark
                                    contact
                                    block_no
                                    area
                                }
                            }
                        }
                        boat {
                            id
                            name {
                                en
                                ar
                            }
                            details {
                                boat_type {
                                    code
                                }
                                reg_number
                                capacity
                                features_amenities {
                                    code
                                }
                                safety_equipment {
                                    code
                                }
                                images {
                                    file_name
                                    size
                                    mime_type
                                    s3_key
                                }
                            }
                        }
                        days_of_week
                    }
                    trip_id
                    trip {
                        trip_id
                        trip_name {
                            en
                            ar
                        }
                        route_id
                        start_time
                        end_time
                        schedule {
                            location_id
                            location {
                                id
                                name {
                                    en
                                    ar
                                }
                            }
                            status_code
                            stop_number
                            arrival_time
                            departure_time
                            remarks
                        }
                        editable {
                            status
                        }
                    }
                    start {
                        location_id
                        stop_number
                        arrival_time
                        departure_time
                        location {
                            id
                            name {
                                en
                                ar
                            }
                        }
                    }
                    end {
                        location_id
                        stop_number
                        arrival_time
                        departure_time
                        location {
                            id
                            name {
                                en
                                ar
                            }
                        }
                    }
                    travel_date
                    segment_order
                    duration_minutes
                    trip_meals_summary {
                        meal_id
                        meal_name_en
                        meal_name_ar
                        meal_count
                    }
                    passengers {
                        passenger_id
                        segment_id
                        booking_id
                        travel_date
                        user_id
                        passenger {
                            given_name
                            family_name
                            date_of_birth
                            email
                            phone_number
                            document_type
                            document_number
                            age_group_code
                            special_needs
                            medical_condition
                            medical_remarks
                             document {
            file_name
            size
            mime_type
            s3_key
          }
                        }
                        seat_info {
                            seat_no
                            seat_type_code
                        }
                        ticket_number
                        qr_code {
                            encrypted
                        }
                        check_in {
                            checkin_id
                            booking_id
                            passenger_id
                            luggage_count
                            travel_date
                            status { 
                                code
                                description {
                                    en
                                    ar
                                }
                            }
                            details {
                                remarks
                                counter_no  
                            }
                            user_audit {
                                created_by
                                created_date
                                modified_by
                                modified_date
                            }
                            luggages {
                                booking_id
                                checkin_id
                                travel_date
                                luggage_id
                                qr_code {
                                    encrypted
                                }
                                status { 
                                    code    
                                    description {
                                        en
                                        ar
                                    }
                                }
                                details { 
                                    weight  
                                    dimensions {
                                        length
                                        width
                                        height
                                    }   
                                    color
                                    tags
                                }   
                                user_audit {
                                    created_by
                                    created_date
                                    modified_by
                                    modified_date
                                }
                            } 
                        }
                    }
                    shuttle_service {
                        provider_id
                        provider_name
                        no_of_passenger
                        description_in_arabic
                        description_in_english
                        price {
                            price
                            tax
                            price_with_tax
                        }
                    }
                    refund {
                        segment_id
                        trip_price
                        cancelled_at
                        refund_amount
                        penalty_amount
                        policy_applied
                        policy_percent
                        refundable_base
                        hours_before_trip
                        trip_departure_time
                        remarks
                    }
                }
                passengers {
                    passenger_id
                    segment_id
                    booking_id
                    travel_date
                    user_id
                    passenger {
                        given_name
                        family_name
                        date_of_birth
                        email
                        phone_number
                        document_type
                        document_number
                        age_group_code
                        special_needs
                    }
                    seat_info {
                        seat_no
                        seat_type_code
                    }
                    ticket_number
                    qr_code {
                        encrypted
                    }
                }
                booking_code
                user_audit {
                    created_by
                    created_date
                }
                price {
                    final_price
                    passengers {
                        passenger_id
                        given_name
                        family_name
                        date_of_birth
                        nationality_code
                        special_needs
                        age_group_code
                        price {
                            seat_type_code
                            price_before_discount
                            discount
                            price_after_discount
                            vat
                            price_with_vat
                        }
                    }
                }
            }
        }
    }
`

export const GET_BOAT_DAY_PASS_PRICE = gql`
    query GetBoatDayPassPrices($page: PageInput!, $priceFilter: BoatDayPassPriceFilterInput) {
        getBoatDayPassPrices(page: $page, price_filter: $priceFilter) {
            code
            success
            message
            total_count
            day_pass_prices {
                master_price_id
                name {
                    en
                    ar
                }
                description {
                    en
                    ar
                }
                valid_from
                valid_to
                day_pass_price_status {
                    code
                    description {
                        en
                        ar
                    }
                }
                price {
                    price_id
                    seat_type {
                        code
                        description {
                            en
                            ar
                        }
                    }
                    price {
                        ADL
                        CHD
                        INF
                        SNR
                    }
                }
                is_editable
            }
        }
    }
`
export const CALCULATE_BOOKING_PRICE = gql`
    query CalculateBookingCost($booking: BookingPriceInput!) {
        calculateBookingCost(booking: $booking) {
            code
            success
            message
            price {
           price_summary {
        price_type
        total_price
        type {
          ar
          en
        }
        unit_no
        unit_price
      }
                        price_summary_total

                user_preferred_currency
                total_price_before_discount 
                total_discount 
                total_price_after_discount 
                total_vat
                total_price_with_vat
                total_add_on_price
                total_add_on_tax
                total_add_on_price_with_tax
                final_price
                passengers {
                    travel_date
                    passenger_id
                    given_name
                    family_name
                    date_of_birth
                    price {
                        seat_type_code
                        price_before_discount
                        discount
                        price_after_discount
                        vat 
                        price_with_vat 
                    }   
                }
                meals {
                    meal_id
                    quantity
                    name_in_arabic
                    name_in_english
                    price {
                        price
                        tax
                        price_with_tax
                    }
                }
                
                extra_luggage {
                    weight_kg
                    quantity
                    price {
                        price
                        tax
                        price_with_tax
                        base
                    }
                }
                special_items {
                    item
                    quantity
                    price {
                        price
                        tax
                        price_with_tax
                    }
                }
                shuttle_service {
                    provider_id
                    provider_name
                    no_of_passenger
                    description_in_arabic
                    description_in_english
                    price {
                        price
                        tax
                        price_with_tax
                    }
                }
            }
        }
    }
`

export const GET_BOOKING_BY_QR = gql`
    query GetBookingByQR($qrCode: NonEmptyString!) {
        getBookingByQR(qr_code: $qrCode) {
            code
            success
            message
            booking {
                booking_id
                booking_code
                price {
                    total
                }
                payment_channel
                trip_segments {
                    segment_id
                    segment_order
                    travel_date
                    passengers {
                        passenger_id
                        ticket_number
                        qr_code {
                            encrypted
                        }
                        price {
                            total
                        }
                    }
                    trip_meals_summary {
                        meal_id
                        meal_name_en
                        meal_name_ar
                        meal_count
                    }
                    start {
                        location_id
                        stop_number
                        arrival_time
                    }
                    trip_locations {
                        location_id
                        stop_number
                        arrival_time
                        departure_time
                        location {
                            id
                            name {
                                en
                                ar
                            }
                        }
                    }
                }
                feedback {
                    token
                    status
                }
                day_pass_booking {
                    max_limit
                    total_booked
                    remaining_quota
                }
                metadata {
                    booking_id
                    travel_date
                    booking_type {
                        code
                        description {
                            en
                            ar
                        }
                    }
                    booking_code
                }
            }
        }
    }
`
